import React from 'react';
import Icon from '../../../components/AppIcon';

const HistoryPane = ({ isOpen, onClose, knowledgeBase, historyData }) => {
  if (!isOpen || !knowledgeBase) return null;

  const getChangeIcon = (changeType) => {
    if (changeType?.includes('Name Changed')) return 'Edit';
    if (changeType?.includes('Link Changed') || changeType?.includes('Doc Uploaded')) return 'Upload';
    if (changeType?.includes('added')) return 'UserPlus';
    if (changeType?.includes('removed')) return 'UserMinus';
    return 'Activity';
  };

  const getChangeColor = (changeType) => {
    if (changeType?.includes('added')) return 'text-success';
    if (changeType?.includes('removed')) return 'text-error';
    return 'text-primary';
  };

  return (
    <>
      <div
        className="fixed inset-0 bg-black/50 z-[400] transition-opacity"
        onClick={onClose}
      />
      <div className="fixed top-0 right-0 h-full w-full md:w-[700px] lg:w-[800px] bg-card border-l border-border z-[500] overflow-y-auto shadow-2xl transform transition-transform">
        <div className="sticky top-0 bg-card border-b border-border p-4 md:p-6 z-10">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
                <Icon name="History" size={20} className="text-primary" />
              </div>
              <div>
                <h2 className="text-lg md:text-xl font-semibold text-foreground">Change History</h2>
                <p className="text-xs md:text-sm text-muted-foreground">{knowledgeBase?.name}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-muted transition-base"
              aria-label="Close panel"
            >
              <Icon name="X" size={20} />
            </button>
          </div>
        </div>

        <div className="p-4 md:p-6">
          <div className="bg-muted/30 rounded-lg border border-border overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full min-w-[600px]">
                <thead>
                  <tr className="border-b border-border bg-muted/50">
                    <th className="text-left py-3 px-4 text-xs md:text-sm font-semibold text-muted-foreground">Timestamp</th>
                    <th className="text-left py-3 px-4 text-xs md:text-sm font-semibold text-muted-foreground">User</th>
                    <th className="text-left py-3 px-4 text-xs md:text-sm font-semibold text-muted-foreground">Changes</th>
                  </tr>
                </thead>
                <tbody>
                  {historyData?.length > 0 ? (
                    historyData?.map((entry, index) => (
                      <tr key={index} className="border-b border-border hover:bg-muted/30 transition-base">
                        <td className="py-3 px-4">
                          <div className="flex items-center gap-2">
                            <Icon name="Clock" size={14} className="text-muted-foreground" />
                            <span className="text-xs md:text-sm text-foreground">
                              {new Date(entry?.timestamp)?.toLocaleString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </span>
                          </div>
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex items-center gap-2">
                            <Icon name="User" size={14} className="text-muted-foreground" />
                            <span className="text-xs md:text-sm font-medium text-foreground">{entry?.user}</span>
                          </div>
                        </td>
                        <td className="py-3 px-4">
                          <div className="flex items-start gap-2">
                            <Icon 
                              name={getChangeIcon(entry?.change)} 
                              size={14} 
                              className={`mt-0.5 ${getChangeColor(entry?.change)}`} 
                            />
                            <span className="text-xs md:text-sm text-foreground">{entry?.change}</span>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="py-8 text-center">
                        <div className="flex flex-col items-center gap-2">
                          <Icon name="FileText" size={32} className="text-muted-foreground" />
                          <p className="text-sm text-muted-foreground">No history available</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HistoryPane;